<template>
  <div class="cart_alert" id="cart_alert" :class="{ hide: productsInCart == 0 , show: productsInCart > 0 && showPop && !orderCopy }">
    <div class="cart_row center clearfix" v-if="productsInCart === 0">
      <div class="empty_cart-title bold">עגלה ריקה, בטן ריקה...</div>
      <div class="empty_cart-sub green">עוד לא מילאת מוצרים בעגלה, אבל סיור קצר באתר יסדר את זה :)</div>
    </div>
    <div class="cart_row clearfix product_item product_item_data" v-if="this.$store.state.showLastProduct" v-bind:data-product-id="lastProduct.id">
      <div class="right cart_img">
        <img v-bind:src="lastProduct.image">
      </div>
      <div class="right cart_title_wrap">
        <div class="cart_title" v-html="lastProduct.name"></div>
        <div class="pr_title_note" v-if="!lastProduct.hide_weight && lastProduct.weight">{{weightText}}</div>
      </div>
      <div class="right cart_col_count">
        <div class="addto_cart">
          <div class="addto_cart_in clearfix">
            <div class="right c_num">
              <input class="addto_cart_num" type="number" @change="updateCart([lastProduct, $event]);" v-model="lastProduct.quantity">
              <div class="c_units">{{ selectedText }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="left cart_col_total">
        <div class="pr_price">
          {{ lastProductPriceTotal }}
          <span class="currency">{{ currencySymbol }}</span>
        </div>
        <div class="clearfix">
          <div class="left pr_price price_sale">
            {{ lastProductPrice }}
            <span class="currency">{{ currencySymbol }}</span>
            /{{
            unitPriceText
            }}
          </div>
          <div class="left pr_price pr_price_old" v-if="lastProduct.oldprice">
            {{ lastProduct.oldprice }}
            <span class="currency">{{ currencySymbol }}</span>
            /{{
            unitPriceText
            }}
          </div>
        </div>
      </div>
      <div class="both"></div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from "vuex";
  export default {
    data() {
      return {
        currencySymbol: wpData.currencySumbol,
        orderCopy: false
      };
    },
    watch: {
      "this.showPop": function(value) {
        if (value) {
          setTimeout(() => {
            this.$store.commit("toggleChangeInCart");
          }, 500);
        }
      },
      orderCopy:function(value){
        if (value) {
          setTimeout(() => {
            this.orderCopy = false;
          }, 3000);
        }
      }
    },
    mounted() {
      var _this = this;
      this.$root.$on('orderCopy',function(){
        _this.orderCopy = true;
      });
    },
    computed: {
      ...mapGetters({
        getProductById: "getProductById",
        selectedTextG: "selectedText",
        unitPriceTextG: "unitPriceText",
        getWeightText: "getWeightText"
      }),
      lastProduct: function() {
        if (this.$store.state.lastProductId) {
          return this.$store.state.lastProductId;
        }
        return 0;
      },
      weightText: function() {
        let text = this.getWeightText(this.lastProduct);
        if (this.lastProduct.text_after_weight) {
          text = text + " " + this.lastProduct.text_after_weight;
        }
        return text;
      },
      showPop() {
        if (this.$route.name == "permenent"){
          return false;
        }
        return this.$store.state.changeInCart;
      },
      selectedText() {
        return this.selectedTextG(this.lastProduct);
      },
      unitPriceText() {
        return this.unitPriceTextG(this.lastProduct);
      },
      lastProductPrice() {
        return parseFloat(this.lastProduct.price).toFixed(2);
      },
      lastProductPriceTotal() {
        const product = this.$store.state.added.find(p => p.id === this.lastProduct.id);
        if (
            (typeof product.salePriceTotal != "undefined" && product.salePriceTotal > 0) ||
            this.isGiftProduct
        ) {
          return parseFloat(product.salePriceTotal).toFixed(2);
        }
        if (
            (product.type === "both" || product.type === "unitaskg") &&
            product.selected === "unit"
        ) {
          return parseFloat(
              product.quantity * product.weight * product.price * product.divide_by
          ).toFixed(2);
        }
        return parseFloat(product.quantity * product.price * product.divide_by).toFixed(2);
      },
      productsInCart: function() {
        if (this.$store.state.added) {
          return this.$store.state.added.length;
        }
        return 0;
      }
    },
    methods: {
      ...mapActions(["updateCart"])
    },
    components: {}
  };
</script>
